import { __decorate } from "tslib";
import Vue from 'vue';
import Component from "vue-class-component";
let ConfirmDialog = class ConfirmDialog extends Vue {
    dialog = false;
    title = '';
    text = '';
    cancel = '';
    confirm = '';
    maxWidth = 350;
    confirmDialog(value) {
        document.dispatchEvent(new CustomEvent('closeConfirmDialog', {
            detail: { confirmed: value },
        }));
        this.dialog = false;
    }
    openConfirmDialog(e) {
        this.title = e.detail.title;
        this.text = e.detail.text;
        this.cancel = e.detail.cancel;
        this.confirm = e.detail.confirm;
        this.maxWidth = e.detail.maxWidth;
        this.dialog = true;
    }
    static async open(title = 'Potvrzení', text = 'Opravdu?', confirm = 'Ano', cancel = 'Ne', maxWidth = 350) {
        document.dispatchEvent(new CustomEvent('openConfirmDialog', {
            detail: { title, text, confirm, cancel, maxWidth },
        }));
        let confirmed = false;
        let resolveFunction = () => { };
        const resolveDialog = (e) => {
            confirmed = e.detail.confirmed;
            resolveFunction();
        };
        await new Promise(resolve => {
            resolveFunction = resolve;
            document.addEventListener('closeConfirmDialog', resolveDialog);
        });
        document.removeEventListener('closeConfirmDialog', resolveDialog);
        return confirmed;
    }
    created() {
        document.addEventListener('openConfirmDialog', this.openConfirmDialog);
    }
    beforeDestroy() {
        document.removeEventListener('openConfirmDialog', this.openConfirmDialog);
    }
};
ConfirmDialog = __decorate([
    Component
], ConfirmDialog);
export default ConfirmDialog;
